export enum PriceType {
  SERVICES = 'Услуги',
  ITEMS = 'Товары',
}
